module.exports = __webpack_public_path__ + "img/EMT-GBM_SPATA.e15d8f90.png";